import React from 'react';
import pancakeswapImg from '../../../images/pancakeswap-icon.png';

export default function PancakeswapIcon() {
  return <img width={15} height={15} className="" src={pancakeswapImg} alt="pancakeswap" />;
}
